import { DocumentList } from "../../Fulfillment/FulfillmentDetails/Documents/DocumentList";
import { useCohortDetails } from "../useCohortDetails";

export function CohortDocuments() {
  const { data, refetch, loading } = useCohortDetails();

  return (
    <DocumentList
      activities={data?.cohort?.currentWorkflow?.activities ?? []}
      tenantId={data?.cohort?.tenantId ?? ""}
      loading={loading}
      onRefetch={refetch}
      refetchQueries={["GetCohort"]}
      showAdvancedTooltips={true}
      cohortMode={true}
      showPaper={true}
      title="Documents"
    />
  );
}
